class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.body = document.querySelector('body');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
    //   closeButton.addEventListener('click', this.close.bind(this));
    // });
    this.notification.addEventListener('click', function(e){
      if(e.target && e.target.dataset.close == ''){
        document.getElementById('cart-notification').classList.remove('active');
        document.body.removeEventListener('click', this.onBodyClick);
        removeTrapFocus(this.activeElement);
        document.getElementById('cart-icon-bubble').style.display = 'flex';
        document.getElementById('cart-icon-bubble-close').style.display = 'none';
        document.querySelector('body').classList.remove('tw-overflow-hidden');
      }
    });
    document.getElementById('cart-icon-bubble').addEventListener('click', this.openSideCart.bind(this), false);
  }

  openSideCart(evt) {
    evt.preventDefault();
    this.renderContents();
  }

  open() {
    // this.notification.classList.add('animate', 'active');
    this.notification.classList.add('active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

    document.getElementById('cart-icon-bubble').style.display = 'none';
    document.getElementById('cart-icon-bubble-close').style.display = 'flex';
    this.body.classList.add('tw-overflow-hidden');
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);

    document.getElementById('cart-icon-bubble').style.display = 'flex';
    document.getElementById('cart-icon-bubble-close').style.display = 'none';
    this.body.classList.remove('tw-overflow-hidden');
  }

  renderContents(parsedState) {
    if (parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
    }

      this.header?.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product'//,
        // selector: `#cart-notification-product-${this.productId}`,
      },
      {
        // id: 'cart-notification-button'
        id: 'cart-icon-bubble-close'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('#cart-icon-bubble')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
